import { GET_BUSINESS_FUNCTION_LIST } from '@nile/itsm/src/graphql';
import { getValidators } from '../utils/helpers';
import { AccountClient } from '@nile/graphql';
import { GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT } from '@nile/banyan/src/Graphql/Mutations/site';

export const getTicketImportFields = (currentProduct) => {
  const ticketFields = [
    {
      label: 'attribute.ticket.referenceId',
      key: 'ticketSourceReferenceId',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.subject',
      key: 'subject',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.description',
      key: 'description',
      type: 'string'
    },
    {
      label: 'attribute.source',
      key: 'source',
      type: 'select',
      selectOptions: [
        {
          label: 'TicketSource.FORM',
          value: 'FORM'
        },
        {
          label: 'TicketSource.AGENT',
          value: 'AGENT'
        },
        {
          label: 'TicketSource.EMAIL',
          value: 'EMAIL'
        },
        {
          label: 'TicketSource.AI',
          value: 'AI'
        },
        {
          label: 'TicketSource.PHONE',
          value: 'PHONE'
        },
        {
          label: 'TicketSource.INTEGRATION',
          value: 'INTEGRATION'
        },
        {
          label: 'TicketSource.SCHEDULE',
          value: 'SCHEDULE'
        },
        {
          label: 'TicketSource.CONTRACT_REMINDER',
          value: 'CONTRACT_REMINDER'
        }
      ],
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'entityAttribute.requester.email',
      key: 'requesterEmail',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ]
    },
    {
      label: 'entityAttribute.technician.email',
      key: 'technician',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ]
    },
    {
      label: 'attribute.addedTime',
      key: 'createdTime',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        }
      ]
    },
    {
      label: 'attribute.updatedTime',
      key: 'updatedTime',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        }
      ]
    }
  ];
  if (currentProduct === 'MSP') {
    ticketFields.push(
      {
        label: 'common.client',
        key: 'client',
        type: 'string',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'common.site',
        key: 'site',
        type: 'string',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      }
    );
  } else if (currentProduct === 'IT') {
    ticketFields.push(
      {
        label: 'common.department',
        key: 'department',
        type: 'select',
        selectOptions: []
      },
      {
        label: 'common.site',
        key: 'site',
        type: 'select',
        selectOptions: [],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      }
    );
  }
  return ticketFields;
};

export const getTicketValidators = (customField) => {
  switch (customField?.columnName) {
    case 'ticketType':
    case 'status':
      return [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ];
      break;
    default:
      return getValidators(customField);
  }
};

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    case 'site':
      return {
        input: {
          sort: [
            {
              attribute: 'name',
              order: 'ASC'
            }
          ]
        }
      };
    case 'clientId':
      return { listInfo: {} };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'department':
      return GET_BUSINESS_FUNCTION_LIST;
    case 'site':
      return GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'department':
      return client?.query({ query });
    case 'site':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'department':
      return 'getBusinessFunctionList';
    case 'site':
      return 'getClientSiteList';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'department':
      return options?.data?.[key].map((el) => {
        return {
          value: `${el.businessFunctionId}`,
          label: `${el.name}`
        };
      });
    case 'site':
      return options?.data?.[key].sites.map((el) => {
        return {
          value: `${el.name}`,
          label: `${el.name}`
        };
      });
    default:
      return options;
  }
};
